/**
 * Fetches per-location inventory via Shopify App Proxy (same-origin).
 * Storefront: GET /apps/{subpath}?product_id={id} — Shopify proxies to your "Proxy URL" in the app config.
 * Theme setting: inventory_app_proxy_subpath (Theme settings → Store inventory API)
 */
(function () {
  'use strict';

  /** Avoid double init when the asset is included from `scripts.liquid` and from `pickup-availability.liquid`. */
  /** @type {any} */
  const w = window;
  if (w.__pickupInventoryApiInitialized) {
    return;
  }
  w.__pickupInventoryApiInitialized = true;

  /**
   * Supports multiple theme event payload shapes.
   * @param {Event} event
   * @returns {string|null}
   */
  function getVariantIdFromEvent(event) {
    /** @type {any} */
    const e = event;
    const id =
      e?.detail?.resource?.id ??
      e?.detail?.variant?.id ??
      e?.detail?.data?.variant?.id ??
      null;
    return id ? String(id) : null;
  }

  /**
   * @param {string} subpath App proxy subpath from Partner Dashboard (e.g. product-inventory)
   * @param {string} productId Shopify product id
   * @param {string | null} variantId Shopify variant id (optional)
   * @returns {string} Absolute URL on the current storefront origin
   */
  function buildUrl(subpath, productId, variantId) {
    const clean = subpath.replace(/^\/+|\/+$/g, '');
    const path = '/apps/' + clean;
    const url = new URL(path, window.location.origin);
    url.searchParams.set('product_id', productId);
    if (variantId) {
      // Send both keys for maximum compatibility with existing app-proxy implementations
      url.searchParams.set('variant_id', variantId);
      url.searchParams.set('variant', variantId);
    }
    return url.toString();
  }

  /**
   * @param {HTMLElement} box
   */
  function fillPickupBox(box) {
    const subpath = (box.dataset.appProxySubpath || '').trim();
    const productId = (box.dataset.productId || '').trim();
    const variantId = (box.dataset.variantId || '').trim() || null;
    if (!subpath || !productId) return;

    const qtyEls = box.querySelectorAll('.pickup-row__qty[data-location-key]');
    if (!qtyEls.length) return;

       var oosLabel = (box.dataset.inventoryOosLabel || '').trim() || 'Out of stock';

    qtyEls.forEach(function (el) {
      el.classList.remove('pickup-row__oos');
      el.textContent = '…';
    });

    const url = buildUrl(subpath, productId, variantId);
    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;

        function parseQty(val) {
          if (typeof val === 'number') return Number.isNaN(val) ? null : val;
          if (typeof val === 'string' && val.trim() !== '') {
            var n = Number(val);
            return Number.isNaN(n) ? null : n;
          }
          return null;
        }
        var totalQty = 0;
        qtyEls.forEach(function (el) {
          var key = el.getAttribute('data-location-key');
          if (key == null) return;
          var val = data[key];
          var parsed = parseQty(val);
              totalQty += parsed || 0;

          if (parsed !== null) {
            if (parsed <= 0) {
              el.classList.add('pickup-row__oos');
              el.textContent = oosLabel;

            } else {
              el.classList.remove('pickup-row__oos');
              el.textContent = String(parsed);
            }
          } else if (val != null && val !== '') {
            el.classList.remove('pickup-row__oos');
            el.textContent = String(val);
          } else {
            el.classList.remove('pickup-row__oos');
            el.textContent = '—';
          }
        });

        var stockStatusEl = document.querySelector('.instock-in-pickup-section');

        if (stockStatusEl) {
          stockStatusEl.textContent = totalQty > 0 ? 'IN STOCK' : 'OUT OF STOCK';
        }
      })
      .catch(function () {
        qtyEls.forEach(function (el) {
          el.classList.remove('pickup-row__oos');
          el.textContent = '—';
        });
      });
  }

  function refreshAll() {
    document.querySelectorAll('.pickup-box[data-app-proxy-subpath]').forEach(fillPickupBox);
  }

  /** @type {any} */ (window).refreshPickupInventoryFromApi = refreshAll;

  // Refresh pickup inventory when variant changes (Product page / featured product / quick add).
  /** @param {Event} event */
  function handleVariantChange(event) {
    const variantId = getVariantIdFromEvent(event);
   // console.log("Herrrrrrrrrrrrrrrr",variantId);
    
   //const pickupBox = document.querySelector('.pickup-box');
    const qtyEls = document.querySelectorAll('.pickup-row__qty[data-location-key]');
    var stockStatusEl = document.querySelector('.instock-in-pickup-section');
        stockStatusEl.textContent = '—';
    if (!variantId) {
      qtyEls.forEach(function (el) {
        el.classList.remove('pickup-row__oos');
        el.textContent = 'Unavailable';
      });
      stockStatusEl.textContent = 'Unavailable';
      return;
    }

    const target = event.target instanceof Element ? event.target : null;
    const scope = target?.closest('.shopify-section, dialog') || document;

    scope.querySelectorAll('.pickup-box[data-app-proxy-subpath]').forEach(function (boxEl) {
      if (!(boxEl instanceof HTMLElement)) return;
      boxEl.dataset.variantId = variantId;
      fillPickupBox(boxEl);
    });
  }

  document.addEventListener('variant:update', handleVariantChange);
  // Some themes/plugins emit a jQuery-style event name
  document.addEventListener('variant:change', handleVariantChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
